import React, { useEffect } from "react";
import { renderRoutes } from "react-router-config";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-rangeslider/lib/index.css";

import { routes } from "./routes";
import Store from "app/context/Store";
import Loader from "app/loader/Loader";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  useEffect(()=> {
    return () => {
      if(window.tokenVerifyInterval) {
        clearInterval(window.tokenVerifyInterval);
      }
    };
  }, []);

  useEffect(() => {
    const handleCopy = (event) => {
      event.preventDefault();
    };

    const handlePaste = (event) => {
      event.preventDefault();
    };

    window.addEventListener('copy', handleCopy);
    window.addEventListener('paste', handlePaste);

    return () => {
      window.removeEventListener('copy', handleCopy);
      window.removeEventListener('paste', handlePaste);
    };
  }, []);

  return (
    <Store>
      <React.Suspense fallback={<Loader loaderMessage="Loading..." />}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            {renderRoutes(routes)}
          </QueryClientProvider>
        </BrowserRouter>
      </React.Suspense>
    </Store>
  );
}

export default App;
